var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_3737_609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 30.6666H51.6666V25.9999C51.6666 19.5599 46.44 14.3333 40 14.3333C33.56 14.3333 28.3333 19.5599 28.3333 25.9999V30.6666H26C23.4333 30.6666 21.3333 32.7666 21.3333 35.3333V58.6666C21.3333 61.2332 23.4333 63.3333 26 63.3333H54C56.5666 63.3333 58.6666 61.2332 58.6666 58.6666V35.3333C58.6666 32.7666 56.5666 30.6666 54 30.6666ZM40 51.6666C37.4333 51.6666 35.3333 49.5666 35.3333 46.9999C35.3333 44.4333 37.4333 42.3333 40 42.3333C42.5666 42.3333 44.6666 44.4333 44.6666 46.9999C44.6666 49.5666 42.5666 51.6666 40 51.6666ZM47.2333 30.6666H32.7666V25.9999C32.7666 22.0099 36.01 18.7666 40 18.7666C43.99 18.7666 47.2333 22.0099 47.2333 25.9999V30.6666Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3737_609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d0c57b8c8bf38ff56f7f31f5a5a34e02.svg";
export { ForwardRef as ReactComponent };